import React from 'react'

const Marketplace = () => {
  return (
    <div>
      Marketplace
    </div>
  )
}

export default Marketplace
